/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onPublishTruckData = /* GraphQL */ `
  subscription OnPublishTruckData($IDWarehouse: ID!) {
    onPublishTruckData(IDWarehouse: $IDWarehouse) {
      IDWarehouse
      load_control_num
      scheduled_pos
      unscheduled_pos
      carrier
      vendor
      dock
      dock_id
      appointment_time
      check_in_time
      po_status
      truck_load_status
      truck_count
      indoor_time
      door
      driver_unload
      door_acknowledge
      detention_status
      truckSequence
      operationType
      underOneHour
      overOneHour
      overOnePointFiveHour
      TruckSequence
      Notes
    }
  }
`;
export const onRealTimeEventFailed = /* GraphQL */ `
  subscription OnRealTimeEventFailed {
    onRealTimeEventFailed {
      eventSource
      eventId
      errorCode
      errorMessage
    }
  }
`;
export const onPublishIMSAnalyticsLoadStatus = /* GraphQL */ `
  subscription OnPublishIMSAnalyticsLoadStatus($IDWarehouse: ID!) {
    onPublishIMSAnalyticsLoadStatus(IDWarehouse: $IDWarehouse) {
      IDWarehouse
      appointment_time
      checkin_time
      door_assign_time
      unloading_time
      released_time
      appointment_count
      checkin_count
      door_assign_count
      unloading_count
      released_count
    }
  }
`;
export const onPublishDMSTruckData = /* GraphQL */ `
  subscription OnPublishDMSTruckData($IDWarehouse: ID!) {
    onPublishDMSTruckData(IDWarehouse: $IDWarehouse) {
      ID
      Control
      IDTruckVendor
      ScheduledPOs
      UnScheduledPOs
      PO
      POStatus
      Dock
      IDDock
      Door
      Carrier
      Vendor
      IDWarehouseCarrier
      ScheduledTime
      ArrivalTime
      CheckInTime
      InDoorTime
      LumpStartTime
      LumpEndTime
      BillsInTime
      BillsOutTime
      OutDoorTime
      CheckOutTime
      BatchStartDatetime
      TruckLoadStatus
      TruckCount
      DriverUnload
      Backhaul
      Dropped
      Acknowledged
      IDBatch
      IDWarehouse
      IsActiveTruckBatch
      IDVendorCommodity
      CreatedOn
      UpdatedOn
      operationType
      underOneHour
      overOneHour
      overOnePointFiveHour
      TruckSequence
      Notes
    }
  }
`;
export const onPublishDmsBucketData = /* GraphQL */ `
  subscription OnPublishDmsBucketData($IDWarehouse: ID!) {
    onPublishDmsBucketData(IDWarehouse: $IDWarehouse) {
      ID
      WarehouseID
      WarehouseName
      StartDate
      EndDate
      StartTime
      EndTime
      Status
      count {
        over_1_5_hr
        over_1_hr
        under_1_hr
      }
    }
  }
`;
export const onCreateSPRODownloadReport = /* GraphQL */ `
  subscription OnCreateSPRODownloadReport($CUID: ID) {
    onCreateSPRODownloadReport(CUID: $CUID) {
      ID
      CUID
      IDWarehouse
      ReportType
      StartDate
      EndDate
      Type
      ReportEmail
      Status
      CreatedOn
      CreatedBy
      URL
    }
  }
`;
export const onReleaseBannerUpdate = /* GraphQL */ `
  subscription OnReleaseBannerUpdate {
    onReleaseBannerUpdate {
      id
      service
      prevVersion
      currentVersion
      isReleaseDone
      isActive
      isDeleted
      forceUpdate
      bannerHeading
      bannerText
      bannerSubtext
      bannerLogo
      bannerDisclaimer
      releaseDate
      notificationType
      startDateTime
      endDateTime
      severity
    }
  }
`;
export const onUpdateSPRODownloadReport = /* GraphQL */ `
  subscription OnUpdateSPRODownloadReport($CUID: ID) {
    onUpdateSPRODownloadReport(CUID: $CUID) {
      ID
      CUID
      IDWarehouse
      ReportType
      StartDate
      EndDate
      Type
      ReportEmail
      Status
      CreatedOn
      CreatedBy
      URL
    }
  }
`;
